import gql from 'graphql-tag';

export const GET_DEPENDENT_OPTION_SETS = gql`
  query DependentOptionSets($lenderFieldId: ID!, $lenderFieldParentSelectedOptionSetId: ID!) {
    getDependentOptionSets(
      lenderFieldId: $lenderFieldId
      lenderFieldParentSelectedOptionSetId: $lenderFieldParentSelectedOptionSetId
    ) {
      displayName
      lenderFieldId
      lenderFieldOptionSetId
      lenderFieldOptionSetParentId
      lenderValue
    }
  }
`;
